import { Injectable } from "@angular/core";
import { EditDialogService } from '../../../core/components/editDialog/editDialogService';
import { CommandInput, CommandTemplate } from '../../../core/entities/commandTemplate/commandTemplate';
import { CommandService, Flow, HasCommands } from '../../../core/services/command/command.service';
import { DynamicDialogRef } from "primeng/dynamicdialog";
import { TaskDialogComponent } from "../../components/task-dialog/task-dialog.component";

@Injectable({
    providedIn: 'root'
  })
export class CreateDefaultTaskCommandCustomFlow implements Flow {

  dialogRef: DynamicDialogRef | undefined;

  constructor(
    private dialogService: EditDialogService
  ) { }

  executeFlow(commandService: CommandService, hasCommands: HasCommands,
    commandTemplate: CommandTemplate, commandInput: CommandInput,
    completionCallback: () => void) {

      this.dialogRef = this.dialogService.open(TaskDialogComponent, {
        header: commandTemplate?.settings?.label,
        width: '760px'
      });
      this.dialogRef.onClose.subscribe((result) => {
        // result is true or false, indiciating if it should refetch
        if(result){
          let parameterObject = {
            taskInput: result
          }
          commandInput.parameters = parameterObject;
          commandService.sendCommand(commandInput, () => {
            completionCallback();
          })
        }
      });
  }
  
}